import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/apiService';
import './AdminLoginPage.css';

// TEMP: default demo credentials — remove before production launch.
// NOTE: this ships in the public JS bundle, so anyone who views source on
// prototype.joinwalkin.com can read it. Clear the pre-fill before the admin
// panel guards anything that matters.
const DEMO_EMAIL = 'admin@walkin.nl';
const DEMO_PASSWORD = 'walkin1234';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  // TEMP: default demo credentials — remove before production launch
  // Pre-fill only; handleSubmit still runs the normal login() auth flow.
  const [email, setEmail] = useState(DEMO_EMAIL);
  const [password, setPassword] = useState(DEMO_PASSWORD);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    const emailLower = email.trim().toLowerCase();
    setError('');
    setLoading(true);
    try {
      const data = await login(emailLower, password);
      const user = data.retailer || data.user || {};
      sessionStorage.setItem('walkin_admin_mode', 'true');
      sessionStorage.setItem('walkin_admin_name', user.name || emailLower);
      sessionStorage.setItem('walkin_admin_role', user.role || 'walkin_admin');
      sessionStorage.setItem('walkin_admin_email', emailLower);
      navigate('/admin/dashboard');
    } catch (err) {
      if (err.status === 401) {
        setError('Onbekend e-mailadres of wachtwoord');
      } else {
        setError(err.message || 'Er ging iets mis. Probeer het opnieuw.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__card">
        <div className="admin-login__brand">
          <div className="admin-login__logo">
            <span className="admin-login__logo-walk">Walk</span>
            <span className="admin-login__logo-in">In</span>
          </div>
          <div className="admin-login__badge">Admin Panel</div>
        </div>

        <h1 className="admin-login__title">Beheerder inloggen</h1>

        {/* TEMP: default demo credentials — remove before production launch */}
        <p className="admin-login__demo-note">
          Demo toegang — verander dit voor live gebruik
        </p>

        <form onSubmit={handleSubmit} className="admin-login__form">
          <label className="admin-login__field">
            <span>E-mailadres</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              required
            />
          </label>
          <label className="admin-login__field">
            <span>Wachtwoord</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              required
            />
          </label>
          {error && <div className="admin-login__error">{error}</div>}
          <button type="submit" className="admin-login__submit" disabled={loading}>
            {loading ? 'Bezig…' : 'Inloggen'}
          </button>
        </form>

        <button
          type="button"
          className="admin-login__back"
          onClick={() => navigate('/')}
        >
          ← Terug naar WalkIn
        </button>
      </div>
    </div>
  );
}
